<template lang="pug">
  .panel.panel-default

    //- 名刺履歴一覧
    .panel-heading.clearfix(v-if="extractable || deletable")
      func-extract(
        v-if="extractable",
        :sid-person="sidPerson",
        :checked-ids="checkedIds",
        :max-length="list.length"
      )
      func-del-card.pull-right(
        v-if="deletable",
        :checked-ids="checkedIds"
      )

    loading(v-if="isLoading")
    card-history-list(
      v-else-if="list.length > 0",
      v-model="list",
      :checkable="extractable || deletable",
      :pCheckedIds="checkedIds",
      :sort="currParams.sort",
      @checkAll="checkAll",
      @checkItem="checkItem"
    )
    .panel-body.text-center(v-else) 名刺履歴情報はありません。

    portal(to="card-bottom")
      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/innerList'
import AppPagination from '@/components/molecules/AppPagination'
import Loading from '@/components/molecules/Loading'
import FuncExtract from '@/components/organisms/functions/FuncExtractCard'
import FuncDelCard from '@/components/organisms/functions/FuncDelCard'
import CardHistoryList from '@/components/organisms/lists/CardHistoryList'

export default {
  name: 'CardTabHistoryList',
  components: {
    AppPagination,
    Loading,
    FuncExtract,
    FuncDelCard,
    CardHistoryList
  },
  mixins: [ mixinList ],
  props: {
    sidPerson: { type: [String, Number], required: true },
    /**
     * @param {Object} POST /bcards のレスポンスのうち1件またはGET /persons/overview
     */
    value: { type: Object, required: true }
  },
  data () {
    return {
      isLoading: true,

      // ソート項目リスト
      // sortOptions: [
      //   {'label': '氏名', 'sort_item': 'name'},
      //   {'label': '会社名', 'sort_item': 'corporate_name'},
      //   {'label': '部署名', 'sort_item': 'dept'},
      //   {'label': '役職', 'sort_item': 'post'},
      //   {'label': '名刺交換日', 'sort_item': 'exchange_date'}
      // ],

      // 初期条件
      initParams: {
        // ページ条件
        page: {page: 1},
        // ソート条件
        sort: {sort_item: 'exchange_date', direction: 'desc'},
        // 検索条件
        conds: {}
      },
      // 現在の条件
      currParams: {
        // ページ条件
        page: {page: 1},
        // ソート条件
        sort: {sort_item: 'exchange_date', direction: 'desc'},
        // 検索条件
        conds: {}
      }
    }
  },
  computed: {
    isExchanged () {
      return this.value.isExchanged
    },
    extractable () {
      // 2件以上ある場合、分割可能
      return this.list.length > 1 && (this.isMgmt || this.isExchanged === this.app_flag.ON)
    },
    deletable () {
      return this.isMgmt
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getList()
      }
    },
    sidPerson (id) {
      if (id) {
        this.getList()
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList (options) {
      const sidPerson = this.sidPerson
      if (!sidPerson) return

      options = options || {}

      let page = options.page || this.currParams.page
      let sort = options.sort || this.currParams.sort
      let conds = options.conds || this.currParams.conds

      const vm = this
      this.isLoading = true

      conds.sid_person = sidPerson

      let params = Object.assign({}, page, sort, conds)

      // 最後の検索条件を保持しておく
      this.currParams = { page, sort, conds }

      this.clearErrorMessages()
      this.isLoading = true

      // API実行
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'bcard',
        method: 'searchHistory',
        params,
        onSuccess (response) {
          if (vm.list.length === 0) {
            vm.$emit('deletes')
          }
        },
        onError (error) {
          const message = vm.getErrorMessage(error) || '名刺履歴情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        },
        finally () {
          vm.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel {
    margin: 0;
    border: 0;
  }
  .panel-heading h4 {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabHistoryList.vue